import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import store from "./redux/store";
import SignIn from "./pages/signin/SignIn";
import Signup from "./pages/signup/Signup";
import ConfirmEmail from "./pages/signup/ConfirmEmail";
import ConfirmEmailMobile from "./pages/signup/ConfirmEmailMobile.js";
import UserOnboarding from "./routes/UserOnboarding";
import ChatBotPage from "./pages/chatbot/ChatBotPage";
import LandingPage from "./pages/landingpage/LandingPage";
import OnboardingPage from "./pages/onboarding/OnboardingPage";
import Password from "./pages/setPassword/Password";
import Username from "./pages/setPsuedoname/Psuedoname";
import PrivateRoutes from "./routes/PrivateRoutes";
import SetPasswordRoute from "./routes/SetPasswordRoute";
import SetLandingPageRoute from "./routes/SetLandingPageRoute";
import SetUsernameRoute from "./routes/SetUsernameRoute";
import SetConversationRoute from "./routes/SetConversationRoute";
import process from "process";
import EndingPage from "./pages/endingpage/EndingPage";
import Profile from "./pages/myProfile/Profile";
import { Wellness } from "./pages/wellness";
import SetHelpPageRoutes from "./routes/SetHelpPageRoutes";
import MyPreferences from "./pages/myProfile/MyPreferences";
import PreviousConversation from "./pages/myProfile/PreviousConversations";
import IndividualConversation from "./pages/myProfile/IndividualConversation";
import UnderConstructionPage from "./pages/underConstruction/UnderConstruction";
import HelpPage from "./pages/helpPage/HelpPage";
import { AUTH_TOKEN } from "./redux/constants/Auth";
import Feedback from "./pages/feedback/feedback.js";
import BillingHistory from "../src/pages/billing/BillingHistory.js";
import PaymentPage from './pages/paymentPage/paymentPage';
import SubscriptionOptions from "./components/SubscriptionOptions/SubscriptionOptions";
import SubscriptionConfirmation from "./components/SubscriptionConfirmation/SubscriptionConfirmation";
import SubscriptionConfirmation2 from "./pages/onboarding/SubscriptionConfirmation2";
import SubscriptionOptions2 from "./components/SubscriptionOptions2/SubscriptionOptions2";
import FreeTrialPage from "./pages/freetrialpage/FreeTrialPage";
import PlanSubscribedPage from "./pages/plansubscribedpage/PlanSubscribedPage";
import LimitTrialPage from "./pages/limittrialpage/LimitTrialPage";
import ParentPage from "./pages/limittrialpage/ParentPage";
import MySubscriptionPage from "./pages/subscriptionpage/MySubscriptionPage";
import ManageSubscriptionPage from "./pages/managesubpage/ManageSubscriptionPage";
import PaymentMethodPage from "./pages/paymentmethodapage/PaymentMethodPage";
import PaymentMethod from "./pages/onboarding/PaymentMethod.js";
import Invoice from "./pages/billing/Invoice.js";
import VoiceSelection from "./pages/voiceselectionpage/VoiceSelection";
import AvatarSettings from "./pages/avatarsettingspage/AvatarSettings";
import VoiceSelection2 from "./pages/voiceselectionpage2/VoiceSelection2";
import AdditionalServices from "./pages/additionalservices/AdditionalServices.js";
import SettingsPage from "./pages/settingspage/SettingsPage.js";
import Favourites from "./pages/additionalservices/Favourite.js";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword.js";
import ResetPassword from "./pages/resetPassword/ResetPassword.js";
import ResetPasswordMobile from "./pages/resetPassword/ResetPasswordMobile.js";
import ResetPasswordCompleted from "./pages/resetPassword/ResetPasswordMobileCompleted.js";
import OnboardingRedirectWrapper from "./pages/OnboardingRedirectWrapper.js";
import ChangeAvatarImage from "./pages/avatarsettingspage/AvatarImage.js";
import Finance from "./pages/additionalservices/Finance.js";
import { accountSetupStatus } from "./api/User.js";
import { Spin, notification } from 'antd';
import ChatboxTextBased from "./components/chatbot.conversation/ChatboxTextBased.js";
import SubscriptionRestrictionModal from "./components/subscriptionIOSRestrictionModal/SubscriptionIOSRestrictionModal";
import io from "socket.io-client";

const socket = io(process.env.REACT_APP_API_URL);

global.Buffer = global.Buffer || require("buffer").Buffer;
if (typeof global.process === "undefined") {
  global.process = process;
}

const HomeRedirect = () => {
  const authToken = localStorage.getItem(AUTH_TOKEN);
  const onboardingComplete = localStorage.getItem('onboardingComplete') === 'true';
  if (authToken && onboardingComplete) {
    return <Navigate to="/landing-page" />;
  } else if (authToken && !onboardingComplete) {
    return <Navigate to="/onboarding/welcome" />;
  } else {
    return <Navigate to="/signin" />;
  }
};

function App() {
  const [isOnboardingComplete, setIsOnboardingComplete] = useState(null);
  const [subscriptionRestrictModalVisible, setSubscriptionRestrictModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Listening for user_deleted event...");
    socket.on("user_deleted", (data) => {
      const loggedInUserId = JSON.parse(localStorage.getItem("userid"));
      if (loggedInUserId && loggedInUserId.toString() === data.userId) {
        notification.error({
          message: "Account Deleted",
          description: "Your account has been deleted by an admin.",
          duration: 3, 
        });
        localStorage.removeItem("AUTH_TOKEN");
        navigate("/signin");
      }
    });

    return () => {
      console.log("Removing user_deleted listener");
      socket.off("user_deleted");
    };
  }, []);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        const response = await accountSetupStatus();
        const isComplete = response.status === 200;
        setIsOnboardingComplete(isComplete);
        localStorage.setItem('onboardingComplete', 'true');
      } catch (error) {
        console.error("Error checking onboarding status:", error);
        setIsOnboardingComplete(false);
        localStorage.setItem('onboardingComplete', 'false');
      }
    };

    if (localStorage.getItem(AUTH_TOKEN)) {
      checkOnboardingStatus();
    } else {
      setIsOnboardingComplete(false);
      localStorage.setItem('onboardingComplete', 'false');
    }
  }, []);

  const handleOnboardingComplete = () => {
    setIsOnboardingComplete(true);
    localStorage.setItem('onboardingComplete', 'true');
    window.dispatchEvent(new Event('onboardingComplete'));
  };

  if (isOnboardingComplete === null) {
    return <div style={{ textAlign: 'center', margin: '20px' }}>
      <Spin size="large" />
    </div>
  }

  const handleModalCancel = () => {
    setSubscriptionRestrictModalVisible(false);
    navigate("/")
  };

  const PlatformAwareRoute = ({ component: Component }) => {
    const userPlatform = localStorage.getItem("userPlatform");
  
    if (userPlatform === "ios") {
      setSubscriptionRestrictModalVisible(true);
      return (
        <SubscriptionRestrictionModal
          visible={subscriptionRestrictModalVisible}
          onCancel={handleModalCancel}
        />
      );
    }

    return <Component />;
  };

  return (
    <div className="App">
      <Provider store={store}>
        <Routes>
          <Route exact path="/" element={<HomeRedirect />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/v2/confirm-email" element={<ConfirmEmailMobile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/password-reset-completed"
            element={<ResetPasswordCompleted />}
          />
          <Route
            path="/reset-password"
            element={
              <ResetPassword onOnboardingComplete={handleOnboardingComplete} />
            }
          />
          <Route
            path="/v2/reset-password"
            element={
              <ResetPasswordMobile
                onOnboardingComplete={handleOnboardingComplete}
              />
            }
          />
          <Route path="/subs" element={<PlatformAwareRoute component={SubscriptionOptions} />} />
          <Route path="/confirm-subs" element={<PlatformAwareRoute component={SubscriptionConfirmation} />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route element={<PrivateRoutes />}>
            <Route
              element={
                <OnboardingRedirectWrapper
                  isOnboardingComplete={isOnboardingComplete}
                />
              }
            >
              <Route
                path="/onboarding/*"
                element={
                  <UserOnboarding
                    onOnboardingComplete={handleOnboardingComplete}
                  />
                }
              />
              <Route exact path="/chat-bot" element={<ChatBotPage />} />
              <Route element={<SetConversationRoute />}>
                <Route
                  exact
                  path="/conversation"
                  element={<OnboardingPage />}
                />
              </Route>
              <Route element={<SetLandingPageRoute />}>
                <Route exact path="/landing-page" element={<LandingPage />} />
              </Route>
              <Route exact path="/wellness-journal" element={<Wellness />} />
              <Route element={<SetHelpPageRoutes />}>
                <Route exact path="/help-page" element={<HelpPage />} />
              </Route>
              <Route element={<SetPasswordRoute />}>
                <Route exact path="/set-password" element={<Password />} />
              </Route>
              <Route element={<SetUsernameRoute />}>
                <Route exact path="/set-username" element={<Username />} />
              </Route>
              <Route
                exact
                path="/under-construction"
                element={<UnderConstructionPage />}
              />
              <Route exact path="/my-profile" element={<Profile />} />
              <Route exact path="/feedback" element={<Feedback />} />
              <Route exact path="/my-preferences" element={<MyPreferences />} />
              <Route
                exact
                path="/previous-conversation"
                element={<PreviousConversation />}
              />
              <Route
                exact
                path="/billing-history"
                element={<BillingHistory />}
              />
              <Route
                exact
                path="/individual-conversation/:id"
                element={<IndividualConversation />}
              />
              <Route exact path="/ending-page" element={<EndingPage />} />
              <Route
                path="/subscription"
                element={<PlatformAwareRoute component={MySubscriptionPage} />}
              />
              ;
              <Route
                path="/subs2"
                element={
                  <PlatformAwareRoute component={SubscriptionOptions2} />
                }
              />
              ;
              <Route
                path="/manage-sub"
                element={
                  <PlatformAwareRoute component={ManageSubscriptionPage} />
                }
              />
              ;
              <Route path="/free-trial" element={<PlatformAwareRoute component={FreeTrialPage} />} />
              <Route path="/plan-sub" element={<PlanSubscribedPage />} />
              <Route path="/limit-trial" element={<LimitTrialPage />} />
              <Route path="/parent" element={<ParentPage />} />
              <Route
                path="/confirm-subs2"
                element={<PlatformAwareRoute component={SubscriptionConfirmation2} />}
              />
              <Route path="/add-payment" element={<PaymentMethod />} />
              <Route path="/payment-methods" element={<PaymentMethodPage />} />
              <Route path="/invoice" element={<Invoice />} />
              <Route path="/voice-selection" element={<VoiceSelection />} />
              <Route path="/voice-selection2" element={<VoiceSelection2 />} />
              <Route path="/avatar-settings" element={<AvatarSettings />} />
              <Route
                path="/additional-services"
                element={<AdditionalServices />}
              />
              <Route path="/favourites" element={<Favourites />} />
              <Route path="/change-avatar" element={<ChangeAvatarImage />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route
                exact
                path="/text-conversation"
                element={<ChatboxTextBased />}
              />
            </Route>
          </Route>
        </Routes>
      </Provider>
    </div>
  );
}

export default App;